import dayjs from "dayjs";
import ContractorDto from "../../dto/Settings/ContractorDto";
import { OFFICE_TYPES } from "../../dto/Company/CompanySettingsDto";

type ContractorModel = Omit<ContractorDto, "creationDate"> & {
  creationDate: dayjs.Dayjs;
};

export const oneContractorsSourceGroups: Array<Array<OFFICE_TYPES>> = [
  ["RUSSIAN_OFFICE", "BELARUSIAN_OFFICE", "KAZAKH_OFFICE", "TURKISH_OFFICE", "THAI_OFFICE", "UAE_OFFICE"],
];

export type ContractorModelWithCompanyOfficeTypes = ContractorModel & {
  companyOfficeTypes: Array<OFFICE_TYPES>;
};

export default ContractorModel;

export class ContractorSettingsDataConverter {
  static convertContractor(contractor: ContractorDto): ContractorModel {
    return { ...contractor, creationDate: dayjs(contractor.creationDate) };
  }

  static convertContractors(contractors: Array<ContractorDto>): Array<ContractorModel> {
    return contractors.map((x) => this.convertContractor(x));
  }
}
